import React from 'react';

import { useTheme } from '@material-ui/core/styles';

import { Header, Footer, RailNavigation, SecondaryNavigation } from '@hydra/common/components';
import LayoutShell from '@hydra/common/shell/LayoutShell';
import { useUserContext, useErrorContext } from '@hydra/common/context';

import { getIsDudaUser, isUnbound } from '@hydra/utils/userUtil';

import isInIframe from '@hydra/utils/isInIframe';

import { useSideNav } from '@hydra/common/customHooks';

import { VisibleItem } from '@hydra/types/navigation';
import { DudaProject } from '@hydra/types';
import { Shell } from '@hydra/types/shell';

interface ProjectShellProps extends Shell {
  section: string
  favicon?: string | null
  dudaProject?: DudaProject | null
}

export default function ProjectShell (props: ProjectShellProps) {
  const theme = useTheme();
  const {
    children,
    dudaProject = null,
    showHeader = true,
    section,
    className,
    hideFooter = false,
    favicon = null,
    bgColor = theme.palette.background.default
  } = { ...props };
  const { sideNavOpen, handleSidenav } = useSideNav();
  const { user } = useUserContext();
  const { error = false } = useErrorContext();
  const isLoggedIn = !!(user && user.id);
  const isNotFound = error && (error.message === 'not_found');
  const showSideNav = isLoggedIn && !isNotFound;
  let showRailNav = showSideNav;
  const inIframe = isInIframe() === null ? true : isInIframe();
  const isDudaUser = getIsDudaUser(user);
  const isUnboundUser = isUnbound(user);

  const navigationItems: VisibleItem[] = isDudaUser
    ? ['dashboard', 'pages', 'performance', 'traffic', 'serp', 'settings']
    : ['dashboard', 'pages', 'marketing-checklist', 'assistant', 'performance', 'traffic', 'serp', 'crawler', 'settings'];
  const visibleItems = navigationItems.filter(x => isUnboundUser ? x !== 'crawler' : x);
  let header = showHeader ? <Header sideNavToggle={handleSidenav} /> : null;
  let sideNavType = 'mini';
  if (isDudaUser && inIframe) {
    header = null;
    showRailNav = false;
    sideNavType = 'none';
  }

  return (
    <>
      {header}
      {
        showRailNav
          ? <RailNavigation
              active={section}
              onClose={handleSidenav}
              open={sideNavOpen}
            />
          : null
      }
      <LayoutShell
        sideNavType={sideNavType}
        sideNav={showSideNav}
        bgColor={bgColor}
        className={className}
      >
        {
          showSideNav
            ? <SecondaryNavigation
                favicon={favicon}
                dudaProject={dudaProject}
                showFooter={isDudaUser}
                active={section}
                onClose={handleSidenav}
                open={sideNavOpen}
                visibleItems={visibleItems}
                hasHeader={!!header}
              />
            : null
        }
        <LayoutShell
          sideNav={showSideNav}
          bgColor={bgColor}
          className={className}
        >
          {children}
        </LayoutShell>
      </LayoutShell>
      {
        !hideFooter
          ? <Footer bgColor={bgColor} />
          : null
      }
    </>
  );
}
